import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import enAxwayReactUIMessages from 'axway-react-ui/lib/messages/en.json';
import ProjectRoute from './components/pages/ProjectRoute';
import store from './stores/Store';
import history from './components/utility/history';
import enBuilderMessages from './messages/en.json';
import './styles/main.scss';

const locales = {
	en: (resolve) => {
		resolve({
			...enAxwayReactUIMessages,
			...enBuilderMessages
		});
	}
};

function loadLocaleData(locale) {
	return new Promise((resolve) => {
		locales[locale](resolve);
	});
}

loadLocaleData('en').then((messages) => {
	// Render the main component into the dom
	// move router into ApplicationRouter.jsx
	ReactDOM.render(
		<Provider store={store}>
			<IntlProvider locale="en" messages={messages}>
				<Router history={history}>
					<Route path={window.$conf.prefix} component={ProjectRoute} />
				</Router>
			</IntlProvider>
		</Provider>,
		document.getElementById('app')
	);
});

if (module.hot) {
	module.hot.accept();
}
